// extracted by mini-css-extract-plugin
export default {"container":"gsrS6T0p","card":"bh_ECfVc","title":"oLBd2QM9","label":"OTGTZysl","name":"FBvNjfaF","form":"MtHJt0J3","mobileButtons":"bo4Tiaev","mobileButton":"WePh27CI"};